import StorePlatformContractWorkflowCommonLoader from '../libraries/store-platform-contract-workflow-common-loader'

export default {

  create() {
    StorePlatformContractWorkflowCommonLoader()
  },
  edit() {
    StorePlatformContractWorkflowCommonLoader()
  }
}
